"use strict";

export default class Settings {
  keyBase: string | null = null;

  constructor(keyBase: string | null = null) {
    this.keyBase = keyBase;
  }

  generateKey(id: string) {
    return this.keyBase ? [this.keyBase, `id${id}`].join(".") : id;
  }

  set(id: string, data: any) {
    const key = this.generateKey(id);
    try {
      const encodedData = JSON.stringify(data);
      localStorage.setItem(key, encodedData);
      return data;
    } catch {
      return null;
    }
  }

  get(id: string) {
    const key = this.generateKey(id);
    try {
      const rawData = localStorage.getItem(key);
      return rawData ? JSON.parse(rawData) : null;
    } catch {
      return null;
    }
  }

  remove(id: string) {
    const data = this.get(id);
    if (data) {
      const key = this.generateKey(id);
      try {
        localStorage.removeItem(key);
      } catch {
        // Do nothing
      }
    }
    return data;
  }
}

/** Remember chat search history. */
export const chatSearchHistory = new Settings("soapbox_chat_search_history");

/** Remember account search history. */
export const accountSearchHistory = new Settings(
  "truth:account_search_history",
);

/** Remember group search history. */
export const groupSearchHistory = new Settings("truth:group-search");

/** Remember predictions search history. */
export const predictionsSearchHistory = new Settings(
  "truth:predictions_search_history",
);
